@if (sessionInfo) {
    <div
        class="font-inter w-full h-full bg-[linear-gradient(359deg,_#FFF_83.33%,_var(--latte-50,_#F9F5F0)_99.08%)]">
        <div class="w-full h-[calc(100vh_-_98px)]">
            <p-scrollPanel #mySessionsScrollPanel [style]="{ width: '100%', height: '100%' }">
                <div class="w-full h-full p-4">
                    <div
                        class="flex flex-col justify-start items-center text-center p-4 relative mb-6 gap-1">
                        <div class="text-color text-base leading-[normal] font-semibold font-normal"
                            >Session at {{ sessionTimeStr }}
                        </div>
                        <div class="text-muted-color text-[13px] leading-[normal]">{{
                            sessionDateAndDurationStr
                        }}</div>

                        @if (editTitle) {
                            <div class="w-full flex gap-1 min-w-0">
                                <p-iconfield class="flex-auto min-w-0">
                                    <input
                                        pSize="small"
                                        class="w-full"
                                        type="text"
                                        [(ngModel)]="newTitle"
                                        pInputText
                                        [pAutoFocus]="true"
                                        (keyup.enter)="onUpdateSessionTitle()"
                                        placeholder="Session title..." />
                                    <p-inputicon
                                        (click)="onUpdateSessionTitle()"
                                        class="cursor-pointer"
                                        [styleClass]="
                                            !updatingTitle ? 'pi pi-reply' : 'pi pi-spinner pi-spin'
                                        " />
                                </p-iconfield>

                                <p-button
                                    severity="secondary"
                                    size="small"
                                    [outlined]="true"
                                    styleClass="aspect-square"
                                    icon="pi pi-times"
                                    (click)="onCancelEditTitle()"></p-button>
                            </div>
                            <div class="text-muted-color text-[12px] leading-[normal]">
                                Only visible to you
                            </div>
                        } @else if (sessionInfo?.title) {
                            <div
                                (click)="editTitle = true"
                                class="cursor-pointer text-muted-color text-[13px] leading-[normal]"
                                >{{ sessionInfo?.title }}</div
                            >
                        } @else {
                            <div
                                (click)="editTitle = true"
                                class="cursor-pointer text-muted-color text-[13px] leading-[normal]"
                                >Add a session title...</div
                            >
                        }
                    </div>

                    <div
                        class="border border-latte rounded-lg p-4 flex flex-col justify-start item-start">
                        @if (sessionInfo.partnerId) {
                            <div class="w-full flex flex-row justify-between items-start">
                                <fm-avatar
                                    [isSnoozed]="sessionInfo.snoozed"
                                    [isSaved]="sessionInfo.saved"
                                    [isQuietMode]="sessionInfo.partnerPreferences.quietMode.value"
                                    [avatarLocation]="sessionInfo.partnerPhoto"
                                    size="xl">
                                </fm-avatar>
                                <div class="flex justify-end items-start gap-1">
                                    <a
                                        target="_blank"
                                        href="{{ messageUrl }}"
                                        size="small"
                                        pButton
                                        severity="secondary"
                                        class="flex no-underline !w-[24px] aspect-square !rounded"
                                        icon="pi pi-send"></a>
                                    <p-button
                                        class="flex"
                                        size="small"
                                        (click)="onUserProfileSelected()"
                                        severity="secondary"
                                        styleClass="!w-[24px] aspect-square !rounded"
                                        icon="pi pi-id-card" />
                                </div>
                            </div>

                            <div class="flex flex-col justify-start items-start gap-1 w-full">
                                <div class="w-full flex flex-row justify-start items-center">
                                    <div
                                        class="block truncate text-left text-color text-14 leading-[normal] font-medium font-inter">
                                        {{ sessionInfo?.partnerDisplayName }}
                                    </div>
                                    @if (lockedInPartner) {
                                        <fa-icon
                                            class="ml-0.5 text-[11px] !text-muted-color"
                                            [icon]="faLock" />
                                    }

                                    <fm-activity-type-icon
                                        class="ml-0.5 text-[11px] !text-muted-color"
                                        [activityType]="sessionInfo.partnerActivityType"
                                        showTooltip="true" />
                                </div>
                                <div
                                    class="block truncate text-left text-12 leading-[normal] text-muted-color font-normal font-inter">
                                    {{ numSessionsString }}
                                </div>
                                <div
                                    class="block truncate text-left text-12 leading-[normal] text-muted-color font-normal font-inter"
                                    >{{ timezoneAndTimeString }}</div
                                >
                            </div>
                        } @else {
                            <div
                                class="block truncate text-left text-color text-14 leading-[normal] font-medium font-inter">
                                Matching...
                            </div>
                            <div
                                class="block text-left text-12 leading-[normal] text-muted-color font-normal font-inter mt-1"
                                >Your partner details will appear here</div
                            >
                        }
                    </div>

                    <div
                        class="cursor-pointer flex justify-between items-center w-full mt-4"
                        (click)="settingsOptionsExpanded = !settingsOptionsExpanded">
                        <div class="text-14 leading-[normal] text-color font-inter font-medium"
                            >Session settings</div
                        >
                        <p-button
                            severity="secondary"
                            [outlined]="true"
                            styleClass="!w-6 !h-9 !p-0"
                            [icon]="
                                settingsOptionsExpanded ? 'pi pi-chevron-up' : 'pi pi-chevron-down'
                            " />
                    </div>

                    @if (settingsOptionsExpanded) {
                        <div
                            class="flex flex-col justify-start items-center p-4 border border-latte rounded-lg mt-2">
                            <label
                                class="w-full text-left text-[12px] text-color font-medium leadning-[normal] font-inter"
                                for="activity"
                                >My Task</label
                            >
                            <div class="w-full flex items-center mt-1 mb-3">
                                <p-select-button
                                    class="w-full h-10"
                                    styleClass="w-full"
                                    [options]="activityOptions"
                                    optionLabel="label"
                                    [ngModel]="selectedActivity.value"
                                    optionValue="value"
                                    [allowEmpty]="false"
                                    [disabled]="updateButtonDisabled"
                                    (onChange)="onActivityTypeChanged($event)">
                                    <ng-template #item let-item>
                                        <div
                                            class="flex flex-col justify-center items-center leading-snug font-medium">
                                            <fa-icon class="text-[10px]" [icon]="item.icon" />
                                            <div class="text-[12px]">{{ item.label }}</div>
                                        </div>
                                    </ng-template>
                                </p-select-button>
                            </div>

                            <div class="flex flex-row justify-between items-center w-full">
                                <div class="flex flex-row justify-between items-center w-full">
                                    <label
                                        class="text-left text-[12px] text-color font-medium leadning-[normal] font-inter"
                                        for="quitemode"
                                        >Quiet Mode:</label
                                    >
                                    <p-toggleSwitch
                                        [disabled]="updateButtonDisabled"
                                        (onChange)="onQuietModeChanged($event)"
                                        class="flex"
                                        [(ngModel)]="selectedQuietMode" />
                                </div>
                            </div>

                            <label
                                class="w-full text-left text-[12px] text-color font-medium leadning-[normal] font-inter mt-3"
                                for="activity"
                                >Match with:</label
                            >
                            <div class="w-full flex items-center mt-2">
                                <p-select
                                    size="small"
                                    class="w-full"
                                    [options]="favoritesPreferenceOptions"
                                    [ngModel]="selectedFavoritesSelection.value"
                                    name="favoritesPreference"
                                    optionLabel="name"
                                    optionValue="value"
                                    [disabled]="updateButtonDisabled"
                                    (onChange)="onFavoritesPreferenceChanged($event)">
                                    <ng-template #selectedItem let-selectedOption>
                                        <div class="flex items-center gap-2">
                                            <i
                                                [ngClass]="selectedOption.icon"
                                                class="!text-[14px]"></i>
                                            <div>{{ selectedOption.name }}</div>
                                        </div>
                                    </ng-template></p-select
                                >
                            </div>

                            <p-button
                                (mouseenter)="setUpdateSettingsButtonStatus()"
                                pTooltip="Preferences cannot be changed once session has started."
                                [tooltipDisabled]="updateSessionAllowed"
                                tooltipPosition="top"
                                (click)="updatePreferences()"
                                [disabled]="updateButtonDisabled"
                                severity="primary"
                                [outlined]="true"
                                size="small"
                                [loading]="updatingPreferences"
                                label="Update settings"
                                class="flex w-full mt-3"
                                styleClass="w-full" />

                            <div
                                class="w-full text-center text-[11px] text-muted-color font-medium leadning-[normal] font-inter mt-2 font-normal">
                                Updating these settings may change your partner.
                            </div>
                        </div>
                    }

                    <div
                        class="cursor-pointer flex justify-between items-center w-full mt-4"
                        (click)="repeatSessionExpanded = !repeatSessionExpanded">
                        <div class="text-14 leading-[normal] text-color font-inter font-medium"
                            >Repeat session</div
                        >
                        <p-button
                            severity="secondary"
                            [outlined]="true"
                            styleClass="!w-6 !h-9 !p-0"
                            [icon]="
                                repeatSessionExpanded ? 'pi pi-chevron-up' : 'pi pi-chevron-down'
                            " />
                    </div>

                    @if (repeatSessionExpanded) {
                        <div
                            class="flex flex-col justify-start items-center p-4 border border-latte rounded-lg mt-2">
                            <div class="w-full flex items-center mt-2">
                                <p-select
                                    size="small"
                                    class="w-full"
                                    [options]="repeatTypeOptions"
                                    [ngModel]="selectedRepeatType.value"
                                    name="recurType"
                                    optionLabel="name"
                                    optionValue="value"
                                    (onChange)="onRecurTypeChanged($event)">
                                    <ng-template #selectedItem let-selectedOption>
                                        <div class="flex items-center gap-2">
                                            <i
                                                [ngClass]="selectedOption.icon"
                                                class="!text-[14px]"></i>
                                            <div>{{ selectedOption.name }}</div>
                                        </div>
                                    </ng-template></p-select
                                >
                            </div>

                            <div class="w-full flex items-center mt-2">
                                <p-select
                                    size="small"
                                    class="w-full"
                                    [options]="repeatFrequencyOptions"
                                    [ngModel]="selectedRepeatFrequency.value"
                                    name="recurType"
                                    optionLabel="name"
                                    optionValue="value"
                                    (onChange)="onRecurFrequencyChanged($event)">
                                    <ng-template #selectedItem let-selectedOption>
                                        <div class="flex items-center gap-2">
                                            <i
                                                [ngClass]="selectedOption.icon"
                                                class="!text-[14px]"></i>
                                            <div>{{ selectedOption.name }}</div>
                                        </div>
                                    </ng-template></p-select
                                >
                            </div>

                            <p-button
                                (click)="bookRecurringSessions()"
                                [loading]="bookingRepeatSessions"
                                severity="primary"
                                [outlined]="true"
                                size="small"
                                label="Save"
                                class="flex w-full mt-3"
                                styleClass="w-full" />
                        </div>
                    }
                    <div class="flex flex-col justify-start items-center w-full mt-8 gap-2">
                        <p-button
                            (mouseenter)="updateJoinSessionButtonStatus()"
                            pTooltip="You can join your session 10 minutes before it starts"
                            [tooltipDisabled]="joinSessionEnabled"
                            tooltipPosition="top"
                            severity="primary"
                            label="Join session"
                            [disabled]="!joinSessionEnabled"
                            class="w-full"
                            styleClass="w-full" />

                        <p-button
                            [disabled]="!cancelSessionEnabled"
                            (click)="onCancelSession()"
                            [loading]="cancelInProgress"
                            severity="danger"
                            variant="text"
                            label="Cancel session"
                            class="w-full mb-8"
                            styleClass="w-full" />
                    </div>
                </div>
            </p-scrollPanel>
        </div>
    </div>
}
